import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { equalsTimeValidator, notBlankValidator } from 'app/shared/utils/customFormValidators';
import swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class ShiftFormService {
  private readonly DEFAULT_COLOR: string = '#000000'

  /**
   * Constructor
   *
   * 
  */
  constructor() { }

  public createShiftForm(name: string | null, start: string | null, end: string | null, color: string | null): FormGroup {
    return new FormGroup({
      name: new FormControl(name, [
        Validators.required,
        notBlankValidator()
      ]),
      start: new FormControl(this.convertToTimeStruct(start), [
        Validators.required
      ]),
      end: new FormControl(this.convertToTimeStruct(end), [
        Validators.required
      ]),
      color: new FormControl(color ?? this.DEFAULT_COLOR, [
        Validators.required,
        Validators.min(7),
        Validators.min(9)
      ]),
    },
      {
        validators: equalsTimeValidator('start', 'end')
      })
  }

  private convertToTimeStruct(time: string | null): NgbTimeStruct | null {
    if (!time) return

    const [hour, minute] = time.split(':').map(item => parseInt(item))

    return { hour, minute, second: 0 }
  }

  public createSubmitText(formOption: string, shiftForm: FormGroup): string {
    const shiftName = shiftForm.value.name

    return `Se ${formOption === 'CREATE' ? 'creará' : 'guardará'} el turno llamado <strong>${shiftName}</strong>`
  }

  public fireSwalAlert(options: SweetAlertOptions): Promise<SweetAlertResult> {
    return swal.fire(options)
  }
}
